import { ref } from 'vue'

/**
 * Estado global (singleton a nivel de módulo) del proceso de sincronización.
 *
 * Lo actualizan los módulos de sync (yjs-sync, connect) y lo lee la UI
 * (indicador de la toolbar del lector) para mostrar feedback fino:
 *   - `connected`: hay un Y.Doc sincronizado activo.
 *   - `persisting`: se está escribiendo a la nube (yjs_documents) o
 *     persistiendo cambios remotos en IndexedDB local.
 *
 * Es deliberadamente simple: un par de booleanos reactivos. Cualquier
 * módulo puede fijarlos; la UI solo los observa.
 */
export const syncConnected = ref(false)
export const syncPersisting = ref(false)

/** Marca el inicio de una operación de persistencia (no anida contadores). */
export function beginPersist() {
  syncPersisting.value = true
}

/** Marca el fin de una operación de persistencia. */
export function endPersist() {
  syncPersisting.value = false
}

/**
 * Envuelve una promesa de persistencia activando/desactivando la bandera.
 * Útil para no olvidar el `endPersist` en rutas de error.
 */
export async function withPersist<T>(fn: () => Promise<T>): Promise<T> {
  beginPersist()
  try {
    return await fn()
  } finally {
    endPersist()
  }
}
